import { styled } from "@mui/material/styles";
import { InputBase } from "@mui/material";

export const CustomSelectInput = styled(InputBase)({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: 612,
    color: "#4d4d4d",
    padding: "18.5px 14px 18.5px 12px",
    margin: "0 auto",
    marginTop: 12,
    marginBottom: 12,
  },
});

export const FavoritesSelectInput = styled(InputBase)({
  "& .MuiInputBase-input": {
    borderRadius: 4,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: 209,
    color: "#4d4d4d",
    padding: "18.5px 14px 18.5px 12px",
    margin: "0 auto",
    marginTop: 12,
    marginBottom: 12,
    marginRight: 25,
  },
});

export const BorderLessSelectInput = styled(InputBase)({
  "& .MuiInputBase-input": {
    fontSize: 16,
    textAlign: "right",
    width: 209,
    color: "#4d4d4d",
    padding: "18.5px 14px 18.5px 12px",
    margin: "0 auto",
    marginTop: 12,
    marginBottom: 12,
    marginRight: 25,
  },
});
